import Vue from 'vue';
import api from '../bu/api';

export default {
	namespaced: true,

	state: () => ({
        fetchingState: 'not-fetched', // not-fetched, fetching, fetched
		services: {},
		servicesArray: []
	}),

	getters: {
		allServices(state) {
			return state.servicesArray;
		},
        sortedAliveServices(state) {
            return state.servicesArray.filter((s) => !s.archived_at)
                .sort((a, b) => b.id - a.id);
        }
	},

	actions: {
		async getService({commit}, id) {
			const response = await api.getService(id);
			return response.data;
		},
		async getAllServices({commit}, force = false) {
            if (!force && this.state.services.fetchingState !== 'not-fetched') {
                return;
            }

			commit('setFetchingState', 'fetching');
			const response = await api.getAllServices();
			commit('setServices', response.data);
			return response.data.map((s) => s.id);
		},
	},

	mutations: {
		setFetchingState(state, fetchingState) {
			state.fetchingState = fetchingState;
		},
        setServices(state, services) {
            services.forEach((s) => {
                Vue.set(state.services, s.id, s);
            });
            Vue.set(state, 'servicesArray', Object.values(state.services));
            state.fetchingState = 'fetched';
        }
	},
}